import {OptionsButtonComponent} from '../shared/components/options-button/options-button.component';
import {TabsHeaderComponent} from './components/tabs-header/tabs-header.component';
import {BasicModalComponent} from './components/modals/basic-modal/basic-modal.component';
import {ConfirmModalComponent} from './components/modals/confirm-modal/confirm-modal.component';
import {PlaceholderModalComponent} from './components/modals/placeholder-modal/placeholder-modal.component';
import {DynamicModalLoaderComponent} from './components/modals/dynamic-modal-loader/dynamic-modal-loader.component';
import {ModalLoaderNgjsService} from './services/modal-loader-ngjs.service';
import {DynamicModalLoaderService} from './services/dynamic-modal-loader.service';
import {CommonOptionsButtonComponent} from '@ispm/shared/components/common-options-button/common-options-button.component';
import {RoutingChangeHandlerService} from './services/routing-change-handler.service';
import {DisclaimerModalComponent} from '@ispm/layout/components/modals/disclaimer-modal/disclaimer-modal.component';
import {WebConfigService} from "@ispm/layout/services/webConfig.service";
import {ModalManagementService} from "@ispm/layout/services/modal-management.service";


export const LAYOUT_SERVICES = [
  ModalLoaderNgjsService,
  WebConfigService,
  DynamicModalLoaderService,
  RoutingChangeHandlerService,
  ModalManagementService
];
export const ModalComponents = [
  BasicModalComponent,
  DisclaimerModalComponent,
  ConfirmModalComponent,
  TabsHeaderComponent,
  OptionsButtonComponent,
  PlaceholderModalComponent,
  DynamicModalLoaderComponent,
  CommonOptionsButtonComponent
];
